export default "__VITE_ASSET__BX71NrRS__"